import { render } from "./edit-class.vue?vue&type=template&id=7cce1a74&lang=html"
import script from "./edit-class.vue?vue&type=script&lang=js"
export * from "./edit-class.vue?vue&type=script&lang=js"

import "./edit-class.vue?vue&type=style&index=0&id=7cce1a74&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__